import { useState } from "react";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import useNav from "core/hooks/useNav";

import Box from "ui/atom/Box";
import Accordion from "ui/base/Accordion";
import Alert from "ui/base/Alert";
import Button from "ui/base/Button";
import Image from "ui/base/Image";
import Page from "ui/Page";

import { useCampaign } from "areas/campaigns/fabric";


Redeem.Details = ({ tokens, partner }) => {
	const theme = useTheme();
	const [open, setOpen] = useState(false);

	const style = {
		root: {
			backgroundColor: "transparent",
			color: theme.palette.secondary.main,
			":before": { content: "none" }
		}
	};

	return (
		<Accordion color="secondary" expanded={open} onChange={() => setOpen(s => !s)} sx={style.root}>
			<Accordion.Summary icon="plus" variant="reverse" color={theme.palette.secondary.main}>
				Details
			</Accordion.Summary>
			<Accordion.Details>
				To redeem this offer, you will need to create a Subly account and accept the Terms of Use. You will be credited with {tokens} Subly tokens for use exclusively at {partner}. You may purchase more at any time for use with any Subly media partner.
			</Accordion.Details>
		</Accordion>
	);
};

export default function Redeem() {
	const campaign = useCampaign();
	const nav = useNav();
	const hasEnded = campaign.data.status === "Ended";
	const isRedeemed = campaign.data.isRedeemed;

	const style = {
		body: { alignItems: "center", mt: 2, gap: 3 },
		logo: { width: "100%", maxWidth: 300 },
		text: { alignItems: "center", textAlign: "center" },
		actions: { maxWidth: 200, width: "100%" }
	};

	return (
		<Page maxWidth="sm">
			<Page.Header title={campaign.title} sx={{ alignItems: "center" }} />
			<Page.Body sx={style.body}>
				<Alert.Error errors={campaign.mutation.error?.errors?.[""]} />
				<Image src={campaign.data.partner.logo} sx={style.logo} />
				<Box.Column gap={2} sx={style.text}>
					<Image src={campaign.data.cover} sx={{ width: 200 }} />
					<Typography variant="h2">{campaign.data.name}</Typography>
					<Typography>{campaign.data.description}</Typography>
				</Box.Column>

				<Box.Column gap={2} sx={style.actions}>
					{hasEnded
						? <Button.Link to="/" variant="contained" color="tertiary" fullWidth>Visit Subly</Button.Link>
						: isRedeemed
							? <Button.Link to="/" hash={campaign.data.code} variant="contained" color="tertiary" fullWidth>Go to campaign</Button.Link>
							: <Button variant="contained" color="tertiary" fullWidth onClick={campaign.redeem} loading={campaign.mutation.isPending}>Redeem</Button>
					}
					<Button variant="outlined" color="tertiary" fullWidth onClick={nav.back}>Back</Button>
				</Box.Column>

				<Redeem.Details tokens={campaign.data.tokens} partner={campaign.data.partner.name} />
			</Page.Body>
		</Page>
	);
}